import type { FC } from 'react';
import React, { useState } from 'react';
import { DEF_PG_SIZE_SUB_MIN } from '../../constants/maximum-page-size';
import { useLocale } from '../../contexts/localeContext';
import { TableContextProvider } from '../../contexts/table/TableContextProvider';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import LiftIoDeviceColumns from '../../models/ColumnDefinitions/LiftIoDeviceColumns';
import { ListQuery } from '../../models/ListQuery';
import IOModuleSearch from '../../models/search/IOModuleSearch';
import { hideColumns } from '../../models/utilities/columnHelper';
import { getIOModules } from '../../services/ioModuleService';
import TableTab from '../tabs/table-tab';
import { WizardStepLayout } from '../wizard/wizard-summary-layout';
import { useFormikContext } from 'formik';
import { IOModule } from '../../models/IOModule';
import { appendFilter } from '../../utilities/filters';
import { getLicenseLimit, LICENSE_ID_MAX_IO_PER_LIFT } from '@/utilities/licenseLimits';

interface IoDeviceStepProps {
    onNext: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onBack: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    setStepDescriptions: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
}

const IoDeviceStep: FC<IoDeviceStepProps> = ({ onNext, onBack, setStepDescriptions }) => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();
    const [selectedIOModuleIds, setSelectedIOModuleIds] = useState<string[]>(values.ioModuleIds || []);
    const [selectedRows, setSelectedRows] = useState<IOModule[]>(values.ioModules || []);
    const maxIoPerLift = getLicenseLimit(LICENSE_ID_MAX_IO_PER_LIFT);

    const onLocalNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setStepDescriptions(prev => ({ ...prev, step5: translate.byKeyFormatted(TranslationKeys.selectedWithCount, { count: selectedIOModuleIds.length }) }));
        setFieldValue('ioModuleIds', selectedIOModuleIds);
        setFieldValue('ioModules', selectedRows);
        onNext(e);
    }

    return <WizardStepLayout onBack={onBack} onNext={onLocalNext} nextDisabled={!(selectedIOModuleIds.length > 0 && selectedIOModuleIds.length <= maxIoPerLift)}>
        <div className='flex w-full' style={{ maxHeight: '410px' }}>
            <TableContextProvider
                dataMethod={(listParameter?: ListQuery) => getIOModules({ ...listParameter, filters: appendFilter(false, 'Used By Lift', 'usedByLift', listParameter?.filters ?? [])})}
                tableDescriptor={hideColumns(LiftIoDeviceColumns, ['type', 'devLicense', 'devReaderSerial', 'site', 'preset'])}
                searchDescriptor={IOModuleSearch}
                useTable
                usePagination
                useFilter
                useSearch
                useSort
                maxPageSize={DEF_PG_SIZE_SUB_MIN}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(TranslationKeys.assignIOModules)}
                    selectRows={true}
                    cyName="ioModule"
                    selectedIds={selectedIOModuleIds}
                    setSelectedIds={setSelectedIOModuleIds}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows} />
            </TableContextProvider>
        </div>
    </WizardStepLayout>
}

export default IoDeviceStep;